import { PlusCircle, AlertTriangle, Users, Calendar } from 'lucide-react';

export const QuickActions = ({ 
  onNewAppointment, 
  onUrgentCase, 
  onViewWaitlist 
}) => {
  const actions = [
    {
      label: 'New Appointment',
      icon: PlusCircle,
      onClick: onNewAppointment,
      color: 'bg-blue-50 text-blue-600 hover:bg-blue-100',
      darkColor: 'dark:bg-blue-900/20 dark:text-blue-400 dark:hover:bg-blue-900/30'
    },
    {
      label: 'Register Urgent Case',
      icon: AlertTriangle,
      onClick: onUrgentCase,
      color: 'bg-red-50 text-red-600 hover:bg-red-100',
      darkColor: 'dark:bg-red-900/20 dark:text-red-400 dark:hover:bg-red-900/30'
    },
    {
      label: 'View Waitlist',
      icon: Users,
      onClick: onViewWaitlist,
      color: 'bg-yellow-50 text-yellow-600 hover:bg-yellow-100',
      darkColor: 'dark:bg-yellow-900/20 dark:text-yellow-400 dark:hover:bg-yellow-900/30'
    }
  ];

  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow p-4 mb-6 transition-colors border border-transparent dark:border-gray-700">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={action.onClick}
            className={`flex items-center p-4 rounded-lg transition-all duration-200 ${action.color} ${action.darkColor}`}
          >
            <action.icon className="h-5 w-5 mr-3" />
            <span className="font-medium">{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};